import { expVal } from '@atlassian/jira-feature-experiments';

const BoardInlineAssignAgent = {
	get(): boolean {
		return expVal('inline_assign_agent_in_board', 'isEnabled', false);
	},
};

export default BoardInlineAssignAgent;
